import { render, staticRenderFns } from "./ProjectsModuleComponent.vue?vue&type=template&id=4b4dd70a&scoped=true"
import script from "./ProjectsModuleComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectsModuleComponent.vue?vue&type=style&index=0&id=4b4dd70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dd70a",
  null
  
)

export default component.exports